import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import LinkButton from '@totallymoney/ui/components/LinkButton'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'
import Image from 'next/image'

import { CreditCardAlternativeProduct } from '@appTypes/EligibilityApi.interface'

import ProsAndConsList from './components/ProsAndConsList'

interface AlternativeProductsTableItemProps {
    item: CreditCardAlternativeProduct
    isPortraitImage: boolean
    applyHref: string
    onApplyPress: (item: CreditCardAlternativeProduct) => void
}

const AlternativeProductsTableItem = ({
    item,
    isPortraitImage,
    applyHref,
    onApplyPress,
}: AlternativeProductsTableItemProps) => {
    const imageDimensions = !isPortraitImage
        ? { width: 220, height: 140 }
        : { width: 140, height: 220 }

    return (
        <Box
            px={['spacingM', 'spacingL']}
            py="space30"
            bg="white"
            borderRadius={theme.borderRadiusMedium}
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.05)"
            display="grid"
            gridGap="space30"
            gridTemplateColumns="repeat(12, 1fr)"
            data-testid={`alternative-product-item-${item.productCode}`}
        >
            <Box gridColumn={'1/13'}>
                <Heading variant="60">{item.header}</Heading>
            </Box>
            <Box
                gridColumn={['1/13', '1/6']}
                display="flex"
                justifyContent={['center', 'flex-start']}
            >
                <Image
                    src={item.imageUrl}
                    alt={`${item.header} card`}
                    loading="lazy"
                    {...imageDimensions}
                />
            </Box>
            <Box
                pt={[0, 'spacingS']}
                gridColumn={'1/13'}
                display="grid"
                gridGap="space30"
                gridTemplateColumns={['1fr', '1fr 1fr']}
            >
                {item.pros != null && item.pros.length > 0 ? (
                    <Box>
                        <ProsAndConsList
                            listHeading="Great for"
                            list={item.pros}
                        />
                    </Box>
                ) : null}
                {item.cons != null && item.cons.length > 0 ? (
                    <Box>
                        <ProsAndConsList
                            listHeading="Beware of"
                            list={item.cons}
                        />
                    </Box>
                ) : null}
            </Box>
            <Box
                gridColumn={['1/13', '6/13']}
                gridRow={['unset', '2']}
                display="flex"
                alignItems="flex-end"
                justifyContent="flex-end"
            >
                <LinkButton
                    href={applyHref}
                    variant="primary"
                    text={isPortraitImage ? 'See more details' : 'Apply now'}
                    onClick={evt => {
                        evt.preventDefault()
                        onApplyPress(item)
                    }}
                />
            </Box>
            {item.representativeExample != null ? (
                <Box gridColumn={'1/13'}>
                    <Box
                        height={1}
                        backgroundColor={theme.productNeutral140}
                        mb="space20"
                    />
                    <Box mx="space30">
                        <Text color="light">{item.representativeExample}</Text>
                    </Box>
                </Box>
            ) : null}
        </Box>
    )
}

export default AlternativeProductsTableItem
